import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { Box, Typography, LinearProgress, List, ListItem, ListItemText, Container, Stack, Button } from '@mui/material';
import { API } from '../conf';
import Header from './Header';
import fond1 from '../asset/fond1.jpg';

export default function RealTimePresence() {
    const containerRef = useRef(null)
    const [reguliers, setReguliers] = useState(0)
    const [generaux, setGeneraux] = useState(0)
    const [delegues, setDelegues] = useState(0)
    const [tt_reguliers, setTtReguliers] = useState(0)
    const [tt_generaux, setTtGeneraux] = useState(0)
    const [tt_delegues, setTtDelegues] = useState(0)
    const [loading, setLoading] = useState(true)

    const handleFullScreen = () => {
        if (containerRef.current) {
            // Demander à passer en plein écran
            containerRef.current.requestFullscreen().catch((err) => {
                console.error("Impossible d'activer le plein écran :", err);
            });
        }
    };

    useEffect(()=>{
        const sessionId = window.location.pathname.split('/')[2]
        const socket = io(API, {
            path: '/socket.io/',
            transports: ['websocket'],
        })
        //rejoindre la session
        socket.emit('joinSession', sessionId)
        socket.on('initPresences', data=>{     
            setReguliers(data.reguliers); setGeneraux(data.generaux); setDelegues(data.reguliers+data.generaux)
            setTtReguliers(data.ttreguliers); setTtGeneraux(data.ttgeneraux); setTtDelegues(data.ttreguliers+data.ttgeneraux)
            setLoading(false)
        })
        socket.on('updatePresences', data=>{ console.log('update presences', data)
            setReguliers(data.reguliers)
            setGeneraux(data.generaux)
            setDelegues(data.reguliers+data.generaux)
        })
        return ()=> socket.disconnect()
    }, [])

    return(
        <Box sx={{display:'flex', flexDirection:'column', height:'100vh'}}>
            <Header/>
            <Box display='flex' flexDirection='column' sx={{flex:1, marginY:'30px'}}>
                <Typography variant="h3" align="center">AGO {new Date().getFullYear()}</Typography>
                <Typography variant="h5" align="center">Présence en temps réel</Typography>
                {loading ? <Typography variant="h5" align="center">Chargement...</Typography>
                :<Button variant='contained' onClick={handleFullScreen} sx={{alignSelf:'flex-end', marginRight:5}}>FullScreen</Button>}
                
                {!loading && <Box ref={containerRef} display='flex' flexDirection='column' justifyContent='center' flex={1} sx={{paddingInline:5, backgroundImage: `url(${fond1})`, backgroundSize: 'cover', backgroundPosition: 'center',}}>
                    <Stack direction='column' spacing={2} alignSelf='flex-start' sx={{width:'80%', justifyContent:'center'}}>
                        <Typography variant="h1" fontSize='160px' align='center' style={{fontWeight: 'bold', color:'white'}}>Délégués présents</Typography>
                        <Typography variant="h1" align='center' sx={{ color: delegues < 74/2 ? 'red' : 'green' }}>
                            {delegues}/74
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Box sx={{ width: '85%', mr: 1 }}>
                                {tt_delegues > 0 && (
                                    <LinearProgress
                                        variant="determinate"
                                        value={(delegues / 74) * 100}
                                        sx={{ height: 30, borderRadius: 5, backgroundColor: 'lightgray', '& .MuiLinearProgress-bar': { backgroundColor: delegues <= 74 / 2 ? 'red' : 'green' } }}
                                    />
                                )}
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                                <Typography variant="h3" sx={{ color: 'text.secondary' }}>
                                {`${((delegues / 74) * 100).toFixed(2)}%`}
                                </Typography>
                            </Box>
                        </Box>
                    </Stack>
                    
                </Box>}
                
            </Box>
        </Box>
    )
}
